import nxModule from 'nxModule';
import AccessType from 'constants/customerAccessType';

nxModule.component('customerGroupAccess', {
  template: '<customer-access access-type="$ctrl.type"></customer-access>',
  controller: function() {
    this.type = AccessType.GROUP;
  }
});